import _flatten from 'lodash/flatten';
import { parse, isBefore, format, addMinutes, parseISO, roundToNearestMinutes } from 'date-fns';
import { transformKeysToSnakeCase } from 'helpers/core';

const TIME_SLOT_INTERVAL = 15;
const START_TIME = '06:00';
const END_TIME = '22:00';

export const getStartTimeOptions = startTime => {
  const startDateTime = startTime
    ? roundToNearestMinutes(startTime, { nearestTo: TIME_SLOT_INTERVAL })
    : parse(START_TIME, 'HH:mm', new Date());
  const endDateTime = parse(END_TIME, 'HH:mm', new Date());
  const timeOptions = [];

  let runningDate = startDateTime;

  do {
    timeOptions.push({ id: format(runningDate, 'HH:mm'), time: runningDate });
    runningDate = addMinutes(runningDate, TIME_SLOT_INTERVAL);
  } while (isBefore(runningDate, endDateTime));

  return timeOptions;
};

export const getFullDayStaffBlocksFromStartTimes = startTimes => {
  return startTimes.map(({ date }) => {
    const parsedDate = parseISO(date);
    const startDateTime = new Date(parsedDate.setHours(0, 0, 0));
    const endDateTime = new Date(parsedDate.setHours(23, 59, 59));

    return { startDateTime, endDateTime };
  });
};

export const transformAlternativeTimeToAPIShape = (payload, duration) => {
  const transformedData = { suggestedTimes: [], blockUnavailable: [] };
  const { blockSelectedDays, startTimes } = payload;

  transformedData.suggestedTimes = _flatten(
    startTimes.map(({ date, times }) => {
      const parsedDate = parseISO(date);

      return times.map(time => {
        const parsedTime = parse(time, 'HH:mm', new Date());

        const startDatetime = `${format(parsedDate, 'yyyy-MM-dd')}T${format(parsedTime, 'HH:mm:ss')}`;
        const endDatetime = `${format(parsedDate, 'yyyy-MM-dd')}T${format(
          addMinutes(parsedTime, duration),
          'HH:mm:ss'
        )}`;

        return { startDatetime, endDatetime };
      });
    })
  );

  // Block all selected days if "Make all other times for these days unavailable to book" checkbox is checked
  if (blockSelectedDays) {
    transformedData.blockUnavailable = startTimes.map(({ date }) => format(parseISO(date), 'yyyy-MM-dd'));
  }

  return transformKeysToSnakeCase(transformedData);
};
